import { DateFormat } from '$shared/constants/Date';
import { getFormatedDateString } from '$shared/helpers/date';
import type { IFile } from '$shared/interfaces/IFile';
import DateString from '$shared/models/DateString';
import mime from 'mime';
import BaseModel from './BaseModel';
import { PreviewSupportedFileType } from '$shared/constants/PreviewSupportedFileType';
import SupportedAttachFileType from '$shared/constants/SupportedAttachFileType';

export class XFile extends BaseModel<IFile> {
  public get id(): string {
    return this.response?.id || '';
  }

  public get createdAt(): DateString {
    return new DateString(this.response?.createdAt);
  }

  public get createdByUserId(): string {
    return this.response?.createdByUserId || '';
  }

  public get createdByUserEmail(): string {
    return this.response?.createdByUserEmail || '';
  }

  public get path(): string {
    return this.response?.path || '';
  }

  public get size(): number {
    return this.response?.size || 0;
  }

  public get providerId(): string | null {
    return this.response?.providerId || null;
  }

  public get facilityId(): string | null {
    return this.response?.facilityId || null;
  }

  public get entityId(): string {
    return this.facilityId || this.providerId || '';
  }

  public get name(): string {
    return this.path.split('/').pop() || '';
  }

  public get folderPath(): string {
    return this.path.replace(XFile.getPrefixPath(this), '').replace(this.name, '');
  }

  public get parsedCreatedDate(): string {
    return getFormatedDateString(this.createdAt?.getRawString(), DateFormat.Default) || '';
  }

  get createdDate(): string {
    return getFormatedDateString(this.createdAt?.getRawString(), DateFormat.Default) || '';
  }

  public get fileType(): string {
    return this.path?.split('.')?.pop() || '';
  }

  public get mimeType(): string | null {
    return mime.getType(this.fileType);
  }

  public get isPending(): boolean {
    return false;
  }

  public get isPreviewSupportedFileType(): boolean {
    return XFile.checkMimeTypeSupportsPreview(this.mimeType);
  }

  public get isSupportAttachment(): boolean {
    return XFile.checkMimeTypeSupportsAttachment(this.mimeType);
  }

  public getAdditionalInfo(): string {
    return '';
  }

  static getPrefixPath(file: XFile): string {
    if (file.facilityId) return `/uploads/facilities/${file.facilityId}/`;

    return `/uploads/providers/${file.providerId}/`;
  }

  static checkMimeTypeSupportsPreview(mimeType: string | null): boolean {
    return Object.values(PreviewSupportedFileType).some((type) => mimeType?.includes(type));
  }

  static checkMimeTypeSupportsAttachment(mimeType: string | null): boolean {
    return Object.values(SupportedAttachFileType).some((type) => mimeType?.includes(type));
  }
}
